<div class="loading-indicator" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="accent"></mat-progress-spinner>
</div>
<div fxLayoutAlign="start" style="margin-top: 20px;">
  <h1>Workers' Compensation Exemption Registration
  </h1>
</div>
<div fxLayoutAlign="center">
  <h2>Your application request type has been submitted successfully!</h2>
</div>
<div fxLayoutAlign="center">
  <p style="color: red;font-weight: bold;"> Application Status =  Pending review by BWC</p>
</div>
<div class="row">
  <div class="col-2"></div>
  <div class="col-2">
    <button (click)="onDownload()" mat-raised-button color="primary" style="min-width: 150px">Download</button>
  </div>
  <div class="col-6">
    <div class="row ">
      <div class="col-11">
        <div class="row">
          <div class="col-6" style="text-align: right; font-weight: bold;">Registration Control #</div>
          <div class="col-6" style="font-weight: bold;">{{summaryData?.registrationControlNumber}}</div>
        </div>
        <div class="row">
          <div class="col-6" style="text-align: right;">Application Request Type
          </div>
          <div class="col-6">{{summaryData?.applicationRequestType}}</div>
        </div>
        <div class="row">
          <div class="col-6" style="text-align: right;">Application Request Type Status
        </div>
          <div class="col-6">{{summaryData?.externalStatusType}}</div>
        </div>
        <div class="row">
          <div class="col-6" style="text-align: right;">Filing Date
        </div>
          <div class="col-6">{{summaryData?.filingDate  | date: 'MM/dd/yyyy'}}</div>
        </div>
        <div class="row">
          <div class="col-6" style="text-align: right;">Applicant Name
        </div>
          <div class="col-6"> {{ summaryData?.lastName ? summaryData?.firstName ? summaryData?.lastName+ ', ' : summaryData?.lastName: '' }}
            {{  summaryData?.firstName ? summaryData?.firstName : '' }}
            {{  summaryData?.middleName ? summaryData?.middleName : '' }}</div>
        </div>
        <div class="row">
          <div class="col-6" style="text-align: right;">Business Entity Name
        </div>
          <div class="col-6">{{summaryData?.filingEntityName}}</div>
        </div>
        <div class="row">
          <div class="col-6" style="text-align: right;">Qualification Type
        </div>
          <div class="col-6">{{summaryData?.qualificationType}}</div>
        </div>
        <div class="row">
          <div class="col-6" style="text-align: right;">Entity Control #
        </div>
          <div class="col-6">{{summaryData?.entityControlNumber}}</div>
        </div>
        <div class="row">
            <div class="col-6" style="text-align: right;">FEIN
          </div>
            <div class="col-6">{{summaryData?.fein}}</div>
          </div>
      </div>
    </div>
    <div class="row " style="margin-top: 20px;">	
	  <p>While we aim to process applications as quickly as possible, please be aware it could take up to 7-10 business days for processing during busy periods. You will receive an email from donotreply@tn.gov once your application has been reviewed. Nothing will be sent via regular mail. Please use a valid email address, and check that email and the spam folder for your documentation.</p>
    </div>
    <div class="row " style="margin-top: 10px;">
      <p>Please mail in payment to the address below. You will need to mail in any required documents as well unless you uploaded them when submitting your application.
    </div>
    <div class="row">
      <div style="font-weight:bold">Mail To:</div>
      <p style="color: #1b365d;"> Tennessee Bureau of Workers' Compensation<br>
        Exemption Registry<br>
        220 French Landing Suite 1-B<br>
        Nashville, TN 37243<br>
      </p>
    </div>
    <div class="row" style="margin-top: 20px;margin-bottom: 130px;">
      <div class="col-2">
        <button (click)="onClose()" mat-raised-button color="primary" style="min-width: 150px">Close</button>
      </div>

    </div>
  </div>
